<template>
  <div class="serviceBrief">
    <p class="title">服务商简介</p>
    <div class="content">
      <img v-if="form.logo" class="mr-16 oLogo" :src="form.logo" alt />
      <img v-else src="@/assets/img/user/company_default_logo.png" class="mr-16 oLogo" />
      <div>
        <p class="font14 fontdark fontbig mb-4">{{ form.oName }}</p>
        <p class="font12">服务提供商</p>
      </div>
    </div>
    <!-- <p class="txt" :class="{'text-hidden': !introduceHidden}">{{ form.oIntroduce }}</p> -->
    <p :class="['txt',(!introduceHidden?'textHidden':'heig')]" ref="introduce">{{ form.oIntroduce }}</p>
    <div v-if="showIntroduceHiddenBtn" class="icon" @click="introduceHidden = !introduceHidden">
      <img v-show="!introduceHidden" src="@/assets/img/service/open.svg" alt />
      <img v-show="introduceHidden" src="@/assets/img/service/close.svg" alt />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      introduceHidden: false,
      showIntroduceHiddenBtn: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.showIntroduceHiddenBtn = this.$refs.introduce.clientHeight < this.$refs.introduce.scrollHeight;
    })
  }
};
</script>

<style lang="scss" scoped>
.serviceBrief {
  position: relative;
  width: 342px;
  // max-height: 355px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
  border-radius: 8px;
  margin-left: 24px;
  padding: 20px;
  .title {
    font-size: 16px;
    font-family: MicrosoftYaHeiSemibold;
    color: #2f4061;
    padding-bottom: 16px;
    border-bottom: 1px solid #f6f7f9;
    font-weight: 600;
  }
  .content {
    margin-top: 16px;
    display: flex;
    .oLogo {
      width: 48px;
      height: 48px;
      border-radius: 20px;
    }
  }
  .txt {
    color: #919caf;
    margin-top: 21px;
    font-size: 14px;
    height: auto;
  }
  .icon {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 10px 0px #dcdfe6;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .textHidden {
    // height: 335px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 7; //行数
    line-clamp: 7;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
  .heig {
    height: auto !important;
  }
}
</style>